<template>
  <lb-drawer
    :value="value"
    heading="Bulk Action Information Owner"
    :loading="loading"
    @input="$emit('input', $event)"
    data-testid="bulk-action-info-owner-drawer"
  >
    <template v-slot:body>
      <v-row class="mt-3">
        <!-- Selected Count Chip -->
        <v-col cols="6" class="my-0 py-0 mb-5">
          <v-chip color="lightpurple" class="caccounting--text" data-testid="bulk-action__selected-count">
            <v-icon class="mr-1">mdi-information-outline</v-icon>
            <span>{{ selectedCount }} information requests selected</span>
          </v-chip>
        </v-col>

        <!-- Action Field (Read-only) -->
        <v-col cols="12" class="my-0 py-0">
          <p class="ma-0 gray--text">Action</p>
          <lb-string value="Replace" label="" disabled data-testid="bulk-action__action-field" />
        </v-col>

        <!-- Information Owner Dropdown -->
        <v-col cols="12" class="my-0 py-1">
          <p class="ma-0 gray--text">Requested from</p>
          <lb-dropdown
            class="flex-grow-1"
            :items="infoOwnerList"
            itemtext="name"
            itemvalue="_id"
            :value="selectedInfoOwner"
            @input="$emit('update-info-owner', $event)"
            label=""
            placeholder="Information owner"
            :error="error"
            data-testid="bulk-action__info-owner-dropdown"
          />
        </v-col>
      </v-row>
    </template>

    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="white--text"
        @click="$emit('replace')"
        data-testid="bulk-action__replace-btn"
      >
        <span>Replace</span>
      </v-btn>
    </template>
  </lb-drawer>
</template>

<script>
export default {
  name: 'BulkActionInfoOwnerDrawer',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedCount: {
      type: Number,
      default: 0,
    },
    infoOwnerList: {
      type: Array,
      default: () => [],
    },
    selectedInfoOwner: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
  },
};
</script>
